import {Task} from "@megaphonenpm/mputils/src/Task.js";
import {CHANGE, COMPLETE} from '@megaphonenpm/mputils/src/constants.js';
import {MegaScreen} from "./MegaScreen.js";

export class LoadThemesTask extends Task {
  constructor () {
    super();
    this.name = 'LOAD_THEMES';
  }

  start () {
    super.start();

    MegaScreen.globals.themeLoader.on(COMPLETE, e => {
      this.done();
    });

    MegaScreen.globals.themeLoader.on(CHANGE, e => {
      // Report task progress
      this.setProgress(MegaScreen.globals.themeLoader.numThemesLoaded/MegaScreen.globals.themeLoader.numThemes);
    });

    // Theme loader task
    MegaScreen.globals.themeLoader.loadThemes(MegaScreen.globals.dataStore.themes);
  }
}
